import React from 'react';
import { Link } from 'react-router-dom';
import {MdAssignment, MdAssignmentTurnedIn, MdAttachment, MdDelete, MdEdit, MdModeEdit} from 'react-icons/md';
import { DropDown } from '~/components';
import { PolicySearchRequestStatus } from '~/pages/PolicySearchRequest/common';
import { useAuth } from '~/hooks';
import {isTryonBot, ROLES} from '~/util/auth';
import { policySearchRequest } from '~/api';
import { useDashboard } from './context';

export const DashboardActionMenu = (user) => ({ data, ...rest }) => {
    const isLocked = data.statusId == PolicySearchRequestStatus.InProgress;
    const isLockOwner = isLocked && user.id == data.modifiedBy.id;
    const isComplete = PolicySearchRequestStatus.isComplete(data.statusId);
    const hasDocs = Array.isArray(data.documents)
        && data.documents.length > 0;

    const { hasRole } = useAuth();
    const isSiteAdmin = hasRole(ROLES.ADMIN);
    const userRoleIsTryonBot = isTryonBot(user.roleId);
    const isModifiedByBot = data.statusId === PolicySearchRequestStatus.Review || isTryonBot(data?.modifiedBy?.roleId);
    const { fetchAll, setAttachments, showAttachmentsModal } = useDashboard();

    return (
        <span {...rest}>
            <DropDown
                wrapperClass="rounded-md border bg-white text-neutral-80 text-sm z-20 filter drop-shadow-xl left-0 top-full mt-1"
                iconClass="text-white"
                iconSize='1.25em'
                buttonClass="p-1 bg-gray-10 text-white focus:outline-none hover:bg-secondary-30 rounded-full flex items-center justify-center"
                text=''>
                <section className="flex flex-col items-stretch w-48 text-gray-80">
                    <p className="font-semibold text-sm p-4 py-2">Action</p>
                    <Link to={`/policySearch/${data.id}?viewOnly=true`} className="py-2 px-4 hover:bg-blue-10 flex items-center">
                        <MdAssignment />
                        <span className="ml-2">View</span>
                    </Link>
                    {isComplete && 
                        <Link to={`/policySearch/${data.id}?editSearch=true`} className="py-2 px-4 hover:bg-blue-10 flex items-center">
                            <MdEdit />
                            <span className="ml-2">Edit</span>
                        </Link>
                    }
                    {isModifiedByBot && !data.completed && (
                        <Link to={`/policySearch/${data.id}`} className="py-2 px-4 hover:bg-blue-10 flex items-center">
                            <MdModeEdit />
                            <span className="ml-2">Update</span>
                        </Link>)}
                    {!userRoleIsTryonBot && !isComplete && (!isLocked || isLockOwner) && (
                        <Link to={`/policySearch/${data.id}`} className="py-2 px-4 hover:bg-blue-10 flex items-center">
                            <MdAssignmentTurnedIn />
                            <span className="ml-2">Complete</span>
                        </Link>
                    )}
                    {isSiteAdmin && (
                        <button 
                            className='py-2 px-4 hover:bg-error-10 flex items-center'
                            onClick={async () => {
                                const confirmDelete = window.confirm("Are you sure you want to delete this lot lookup record?");
                                if(confirmDelete) {
                                    await policySearchRequest.softDelete(data.id);
                                    await fetchAll();
                                }
                            }}
                        >
                            <MdDelete />
                            <span className='ml-2' >Delete</span>
                        </button>
                    )}
                    {hasDocs && (
                        <button 
                            className='py-2 px-4 hover:bg-blue-10 focus:outline-none flex items-center rounded-b-md'
                            onClick={() => {
                                setAttachments(data.documents);
                                showAttachmentsModal();
                            }}>
                            <MdAttachment className='mr-2'/>
                            Attachments
                        </button>
                    )}
                </section>
            </DropDown>
        </span>
    );
};
